import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/sub-category-products`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchSubCategoryProducts = (payload) => apiHelper(API_URL, 'POST', payload, headers);
